module.exports = __webpack_public_path__ + "static/media/zip.eb4aa556.svg";